export interface IAttachmentHeadersRequest {
    ono: number;
    tno?: number;
}